import { render, staticRenderFns } from "./writeAi.vue?vue&type=template&id=fd29632a&scoped=true"
import script from "./writeAi.vue?vue&type=script&lang=js"
export * from "./writeAi.vue?vue&type=script&lang=js"
import style0 from "./writeAi.vue?vue&type=style&index=0&id=fd29632a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd29632a",
  null
  
)

export default component.exports